
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './Cards.module.css';

const Cards = ({ title, value, change, isPositive }) => {
    console.log("");    
  return (
  <div className={styles['stat-tile']}>
  <div className={styles['tile-header']}>{title}</div>
  <div className={styles['tile-body']}>
    <div className={styles['tile-value']}>{value}</div>
  </div>
  <div className={styles['tile-footer']} />
</div>


  );
};

Cards.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  
};

Cards.defaultProps = {
  isPositive: true
};

export default Cards;
